import { CommonHelperFunctions } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export interface IDefaultStyleResponse {
  [key: string]: any;
}

export interface IAllDefaultStylesResponse {
  fill: IDefaultStyleResponse;
  border: IDefaultStyleResponse;
  shadow: IDefaultStyleResponse;
  typography: IDefaultStyleResponse;
  position: IDefaultStyleResponse;
  fillMobile: IDefaultStyleResponse;
  borderMobile: IDefaultStyleResponse;
  shadowMobile: IDefaultStyleResponse;
  typographyMobile: IDefaultStyleResponse;
  positionMobile: IDefaultStyleResponse;
}

export class DefaultStyleService {
  static async getDefaultFillStyles(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/fill`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultBorderStyles(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/border`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultShadowStyles(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/shadow`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultTypographyStyles(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/typography`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultPositionStyles(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/position`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultFillStylesForMobile(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/fill/mobile`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultBorderStylesForMobile(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(
        `${backendUrl}/defaultstyle/border/mobile`
      );
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultShadowStylesForMobile(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(
        `${backendUrl}/defaultstyle/shadow/mobile`
      );
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultTypographyStylesForMobile(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(
        `${backendUrl}/defaultstyle/typography/mobile`
      );
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getDefaultPositionStylesForMobile(): Promise<IDefaultStyleResponse> {
    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(
        `${backendUrl}/defaultstyle/position/mobile`
      );
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getAllDefaultStyles(): Promise<IAllDefaultStylesResponse> {
    try {
      const response: AxiosResponse<IAllDefaultStylesResponse> = await Axios.get(`${backendUrl}/defaultstyle/all`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }

  static async getStylesByType(
    styleType: "fill" | "border" | "shadow" | "typography" | "position",
    isMobile: boolean = false
  ): Promise<IDefaultStyleResponse> {
    const endpoint = isMobile ? `${styleType}/mobile` : styleType;

    try {
      const response: AxiosResponse<IDefaultStyleResponse> = await Axios.get(`${backendUrl}/defaultstyle/${endpoint}`);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      throw error;
    }
  }
}
